import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/chat',
    name: 'chat',
    component: () => import('../views/ChatView.vue')
  },
  {
    path: '/admin',
    redirect: '/admin/qa'
  },
  {
    path: '/admin/login-Z2m7JyRN',
    name: 'admin-login',
    component: () => import('../views/admin/AdminLoginView.vue')
  },
  {
    path: '/admin/qa',
    name: 'admin-qa',
    component: () => import('../views/admin/AdminQaView.vue')
  },
  {
    path: '/admin/sessions',
    name: 'admin-sessions',
    component: () => import('../views/admin/AdminSessionsView.vue')
  },
  {
    path: '/admin/human-resolved-qas',
    name: 'admin-human-resolved-qas',
    component: () => import('../views/admin/AdminHumanResolvedQasView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
